import { Box } from "@mui/material"
import classNames from 'classnames';


export const HorizontalCarrouselComponent = ({ children, className}: { children?: React.ReactNode, className?: string}) => {
    return <Box className={classNames("horizontal-carrousel-items", "hide-scrollbar", className)}>
            {children}
        </Box>
}